<template>
  <my-details-sidebar/>
  <router-view/>
</template>

<script lang="ts">
import MyDetailsSidebar from "authentication/components/mydetails/MyDetailsSidebar.vue";
import { defineComponent } from "vue";

export default defineComponent({
  components: { MyDetailsSidebar },
});
</script>
